export default function StatusBadge({ status }) {
  const s = (status || "").toUpperCase();
  let cls = "badge-run";
  if (s === "PASS") cls = "badge-pass";
  else if (s === "FAIL") cls = "badge-fail";
  else if (s === "RUNNING") cls = "badge-run";
  return <span className={`badge ${cls}`}>{status || "—"}</span>;
}
